import React from "react";
import imagePaths from "../../source/images.json";
import { useTranslation } from "react-i18next";

const VideoPanel = () => {
  const { t } = useTranslation("labels"); // Use the translation hook for the "labels" namespace
  const { homeVideo } = imagePaths;

  // Check if the video is available
  if (!homeVideo) {
    return <div>Video not available</div>;
  }

  return (
    <div className="video-container">
      <video id="videoid" className="video" loop autoPlay muted>
        <source src={homeVideo} type="video/mp4" />
        <source src={homeVideo.replace(".mp4", ".webm")} type="video/webm" />
        Your browser does not support the video tag.
      </video>
      <div className="video-text">
        <h1>{t("Grace")}</h1> {/* Use the translation function here */}
        <div className="video-desc">
          <h2>{t("Marian")}</h2> {/* Use the translation function here */}
          <p>{t("Marian_Desc")}</p> {/* Use the translation function here */}
        </div>
   <br /> 
      <div className="video-desc1 text-align-right mt-2" style={{
        textAlign: 'left',
        padding: '0 10px',
        fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
        wordBreak: 'break-word'
      }}>

        <span style={{ display: 'inline-block', marginBottom: '5px' }}>
          {"✨ Upcoming Convention ✨ Register 👉"}{" "}
        </span>
        <a
          href={`${process.env.PUBLIC_URL}/retreat-registration?id=7`}
          className="blink"
          style={{
            color: "White",
            textAlign: "left",
            textDecoration: "underline",
            fontWeight: "bold",
            textShadow: "0 0 8px orange",
            display: 'inline-block',
            wordBreak: 'break-word'
          }}
        >
          Atlanta Krupabhishekam Convention{" "}
        </a>
        </div>
      </div>
    </div>
  );
};

export default VideoPanel;
